import { render, staticRenderFns } from "./dialogBidDetail.vue?vue&type=template&id=9fa3b68e&scoped=true"
import script from "./dialogBidDetail.vue?vue&type=script&lang=js"
export * from "./dialogBidDetail.vue?vue&type=script&lang=js"
import style0 from "./dialogBidDetail.vue?vue&type=style&index=0&id=9fa3b68e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fa3b68e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9fa3b68e')) {
      api.createRecord('9fa3b68e', component.options)
    } else {
      api.reload('9fa3b68e', component.options)
    }
    module.hot.accept("./dialogBidDetail.vue?vue&type=template&id=9fa3b68e&scoped=true", function () {
      api.rerender('9fa3b68e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clue/components/dialogBidDetail.vue"
export default component.exports